import { useEffect, useState } from 'react';

import { EmbeddedEvent } from '../looker/types';
import { isValidLookerEvent, handleLookerEvent } from '../looker/utils';

/**
 * This hook get a list of iframe DOM references where the embedded Looker dashboards are running,
 * so that it could handle Looker 'message' events sent from those iframes.
 * @param iframeElArr A list of iframe DOM reference
 */
export const useHandleLookerEvents = (iframeElArr: HTMLIFrameElement[]) => {
  const [hasLoadDashboardInIframeError, setHasLoadDashboardInIframeError] = useState(false);
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      // All iframes will be put under the same content window
      const contentWindow = iframeElArr.find(el => el !== null)?.contentWindow;
      if (isValidLookerEvent(event, contentWindow)) {
        const embeddedEvent: EmbeddedEvent = JSON.parse(event.data);
        handleLookerEvent(embeddedEvent, () => setHasLoadDashboardInIframeError(true));
      }
    };
    window.addEventListener('message', handler);
    return () => {
      window.removeEventListener('message', handler);
    };
  }, [iframeElArr]);
  return {
    hasLoadDashboardInIframeError,
  };
};
